import React, {useCallback} from 'react'
import {MemoOptionIconButton} from 'module/Memo/component/MemoOptionIconButton'
import {css} from '@emotion/react'
import {HighlightedTextComponent} from 'component/HighlightedTextComponent'
import {SlctOption, SlctOptionProps} from 'component/Slct/SlctType'
import {useDispatch} from 'react-redux'
import {memoToggleAction} from 'module/Memo/action/MemoAction'
import {getOptionLabel} from 'component/Slct/getOptionLabel'

const cssRoot = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	padding-left: 6px;
	padding-right: 6px;
	height: 100%;
	cursor: default;
	user-select: none;

	&.SlctCursor {
		background: #0c73c9;
		color: #ffffff;
	}
`
const cssOption = css`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
`
const cssOptionActive = css`
	background: #68cef6;
	color: #000000;
`
const cssMemo = css`
	position: absolute;
	right: 0;
`

export function SlctOptionComponent<Option extends SlctOption>({
	option,
	selectProps,
	index,
}: SlctOptionProps<Option>) {
	const dispatch = useDispatch()
	const {memo, inputValue, value, cursor, setCursor} = selectProps
	const cssCls = [cssRoot]
	if (value || value === 0) {
		if (option.value === value) cssCls.push(cssOptionActive)
	}
	const displayValue = getOptionLabel(selectProps.displayFormat, option.value, option.label)
	const selected = cursor === index

	return <div
		className={selected ? 'SlctCursor' : undefined}
		css={cssCls}
		onMouseEnter={useCallback(() => setCursor(index), [index, setCursor])}
	>
		<div css={cssOption} title={displayValue}>
			<HighlightedTextComponent text={displayValue} searchTerm={inputValue}/>
		</div>
		<MemoOptionIconButton
			css={cssMemo}
			dispatchMemoToggleAction={() => {
				const {memoKey, sizeMax} = memo || {}
				if (!sizeMax || !memoKey) return;
				dispatch(memoToggleAction({memoKey, sizeMax, element: option}))
			}}
			element={option}
		/>
	</div>
}